module.exports = __webpack_public_path__ + "static/img/green-sm.5e14600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/green-sm.png
// module id = zzU6
// module chunks = 1